module.exports = __webpack_public_path__ + "img/国有大型能源化工集团改革路径的设计与实践—中国平煤神马能源化工集团有限责任公司—1-1.f5594e45.jpg";